import { __read } from 'tslib';
import { createContext } from '../../utils/createContext.js';

var _a = __read(createContext({
    name: "TabList",
}), 2), useTabPanelsContext = _a[0], TabPanelsContext = _a[1];
var TabPanelsProvider = TabPanelsContext.Provider;

export { TabPanelsProvider, useTabPanelsContext };
//# sourceMappingURL=TabsPanelsContext.js.map
